import {periodStateActions} from '../../const/actionType';

const initialState = {
  periods: [],
  selected: null,
};

export default function periodState(state = initialState, action) {
  switch (action.type) {
    case periodStateActions.SET_PERIODS:
      return {...state, periods: action.periods};
    case periodStateActions.SET_SELECTED_PERIOD:
      return {...state, selected: action.selected};
    case periodStateActions.RESET_SELECTED_PERIOD:
      return {...state, selected: null};

    default:
      return state;
  }
}
